import type { Cart } from '@ab-core/graphql/dist';
import { ACTIVECART } from '@ab-core/hooks/cartNew/activeCart/activeCart';
import type { MutationFunctionOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { REMOVE_CUSTOM_LINEITEM } from './removeCustomLineItemMutation';

type DeleteCustomLineItemType = {
    success: boolean;
    error: boolean;
    errorMessage?: string;
    pending: boolean;
    response?: Cart;
    deleteCustomLineItem: (options?: MutationFunctionOptions) => void;
};
const DeleteCustomLineItem = (cartId?: string | string[], lineItemId?: string): DeleteCustomLineItemType => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState(undefined);
    const [pending, setPending] = useState(false);

    const [deleteCustomLineItem, { loading }] = useMutation(REMOVE_CUSTOM_LINEITEM, {
        variables: {
            cartId,
            lineItemIds: lineItemId
        },
        update: () => {
            setSuccess(false);
            setErrorMessage('');
            setError(false);
        },
        onCompleted: (res) => {
            setResponse(res);
            setSuccess(true);
            setPending(false);
        },
        onError: (err) => {
            setErrorMessage(err.message);
            setError(true);
            setPending(false);
        },
        refetchQueries: [{ query: ACTIVECART }]
    });
    useEffect(() => {
        if (loading === true) {
            setPending(true);
            setSuccess(false);
            setError(false);
        }
    }, [loading]);

    return {
        deleteCustomLineItem,
        success,
        error,
        response,
        errorMessage,
        pending
    };
};

export default DeleteCustomLineItem;
